import createVueApp from '@phoenix/createVueApp';
import LightBox from '@maison/components/product/LightBox.vue';
import { PhxVideoPlayer, PhxBackgroundVideo } from '@phx-styleguides/jlc';

document.querySelectorAll('.phoenix-product-light-box').forEach((el) => {
  const app = createVueApp();
  app.component('LightBox', LightBox);
  app.component('PhxVideoPlayer', PhxVideoPlayer);
  app.component('PhxBackgroundVideo', PhxBackgroundVideo);
  app.mount(el);
});
